
























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "@/models/Application";
import { Debouncer } from "@/models/Debouncer";
import { Staff } from "@/viewmodels/Staff";
import { UserType } from "@/services/LoginService";

@Component({})
export default class extends Vue {
  public collection = app.staffCollection;
  public search: string = "";

  public model: Staff = new Staff({}, this.collection);
  public selectedModel: Staff | null = null;

  public dialog = false;
  public formTitle: string = "Add Staff";

  public showContainer = true;

  public userTypes = [
    { id: UserType.Administrator, name: "Administrator/Owner" },
    { id: UserType.Waiter, name: "Waiter" },
    { id: UserType.Cook, name: "Cook" },
    { id: UserType.Bartender, name: "Bartender" },
    { id: UserType.Driver, name: "Driver" }
  ];

  public headers = [
    { text: "First Name", value: "first_name" },
    { text: "Last Name", value: "last_name" },
    { text: "Email", value: "email" },
    { text: "Phone", value: "phone" },
    { text: "Age", value: "age" },
    { text: "Availability", value: "availability" },
    { text: "Actions", value: "" }
  ];

  public rowsPerPageItems = [-1];
  public pagination = {
    rowsPerPage: -1
  };

  public showPassword = false;

  public mounted() {
    this.search = this.collection.search;
    this.collection.refreshData();
  }

  @Watch("search")
  public onSearchChange() {
    this.collection.doSearch(this.search);
  }

  public remove(model: any) {
    const dialog: any = (this.$root as any).$confirm;

    dialog("Delete", "Are you sure?").then((confirm: boolean) => {
      if (confirm) {
        model.delete();
      }
    });
  }

  public close() {
    this.dialog = false;
  }

  public async save() {
    try {
      await this.model.save();
      this.dialog = false;
      this.$store.dispatch("showSnackbar", { message: "Saved succesfully!" });

      this.showContainer = false;
      this.$nextTick(() => {
        this.showContainer = true;
      });
    } catch (e) {
      this.$store.dispatch("showSnackbar", {
        message: "Whoops, error while saving data!"
      });
    }
  }

  public add() {
    this.model = new Staff({}, this.collection);
    this.dialog = true;
  }

  public edit(item: Staff) {
    this.model = item;
    this.dialog = true;
  }

  private async onFileSelect(file: any) {
    if (file) {
      const response = await app.uploadService.upload(
        file,
        "/staff/upload/" + this.model.id
      );
      this.$store.dispatch("showSnackbar", {
        message: "Image uploaded succesfully!"
      });
      app.refreshData();
    }
  }
}
